export default function getResource(label, vars = []) {
    const resources = {
        multiLocation: 'Plusieurs autres heures et emplacements',
        otherLocations: `${vars[0]} autres emplacements`,
        virtual: 'Services virtuels'
    };

    return resources[label];
}
